import { render, staticRenderFns } from "./ArtistSongList.vue?vue&type=template&id=239905d0&"
import script from "./ArtistSongList.vue?vue&type=script&lang=ts&"
export * from "./ArtistSongList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports